{
  "name": "smart-pensjon-web",
  "version": "1.239.1",
  "groupId": "no.storebrand.web.clients",
  "engines": {
    "node": ">=24.15.0",
    "pnpm": ">=12"
  },
  "packageManager": "pnpm@12.8.1+sha512.f64ba907507f5ceafe06c8d38e6052d0179444580ec1279ddd5bfc11cb48aa8a2644b66598e07e761da84872a9fc57d5f902b87fa49d024198d558612aabbe45",
  "scripts": {
    "ng": "ng",
    "start": "pnpm run curl-fms-pending && ng serve",
    "start:port-5000": "ng serve --port 5000 --disable-host-check",
    "start:backend": "node scripts/start-backend.js",
    "ng-high-memory": "node --max_old_space_size=16000 ./node_modules/@angular/cli/bin/ng",
    "build": "pnpm run curl-fms-active && pnpm swagger && tsc --noEmit && pnpm run ng-high-memory build --configuration production",
    "build:local": "pnpm run curl-fms-active && tsc --noEmit && pnpm run ng-high-memory -- build --configuration production",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:debug": "playwright test --debug",
    "e2e:report": "playwright show-report",
    "e2e:install": "playwright install --with-deps",
    "test": "pnpm swagger && pnpm run curl-fms-active && vitest run --coverage",
    "test:watch": "pnpm run curl-fms-active && vitest",
    "test:ui": "vitest --ui",
    "lint": "ng lint smart-pensjon-web",
    "lint:fix": "ng lint smart-pensjon-web --fix",
    "prettify": "prettier --list-different **/*.{js,json,ts,html,css,scss} !**/{dist,e2e,.vscode,.angular}/**",
    "prettify-write": "prettier --write **/*.{js,json,ts,html,css,scss} !**/{dist,e2e,.vscode,.angular}/**",
    "prettify-nix": "prettier --list-different '**/*.{js,json,ts,html,css,scss}' '!**/{dist,e2e,.vscode,.angular}/**'",
    "prettify-write-nix": "prettier --write '**/*.{js,json,ts,html,css,scss}' '!**/{dist,e2e,.vscode,.angular}/**'",
    "curl-fms-active": "fms fetch -d nyt -c smart-pensjon-web -v active src/assets/fms",
    "curl-fms-pending": "fms fetch -d nyt -c smart-pensjon-web -v pending src/assets/fms",
    "prepare": "is-ci || husky install",
    "type-check": "tsc --noEmit",
    "generate-typedefs-graph": "graphql-codegen",
    "generate-types-bank-account-rest": "./generate-typescript-from-rest-schema.sh https://t.stb.intra/gcp/bank-account-rest-api/v3/api-docs src/app/services/api/bank-account-rest-api.types.ts",
    "generate-types-benefits-rest": "./generate-typescript-from-rest-schema.sh https://t-benefit-api.enterprise.storebrand.no/v3/api-docs src/app/services/benefits-rest-api.types.ts",
    "swagger": "rimraf src/app/api && node ./scripts/build-openapi.js",
    "swagger-fetch": "rimraf swagger-gen/swagger && bash scripts/fetch-swagger.sh",
    "unpin-backend": "git checkout HEAD -- swagger-gen/swagger/smart-pensjon-swagger.json && pnpm swagger && rimraf swagger-gen/.backend-pin",
    "postbuild": "node build-utils/brotli-compress.js"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --ext .ts,.html"
    ],
    "*.{js,json,css,scss,md}": [
      "prettier --write"
    ],
    "swagger-gen/swagger/smart-pensjon-swagger.json": [
      "node scripts/check-backend-pin.js"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.1",
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/platform-browser-dynamic": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@apollo/client": "^4.2.7",
    "@floating-ui/dom": "1.2.6",
    "@graphql-tools/mock": "^9.1.18",
    "@graphql-tools/schema": "^10.1.5",
    "@storeblocks/accordion-ng": "^19.0.0",
    "@storeblocks/alert-ng": "^20.1.1",
    "@storeblocks/badge-ng": "^22.0.2",
    "@storeblocks/breadcrumbs-ng": "^3.0.2",
    "@storeblocks/button-ng": "^17.1.1",
    "@storeblocks/card-info-ng": "^18.0.1",
    "@storeblocks/card-nav-ng": "^21.0.0",
    "@storeblocks/card-navigation-ng": "^18.0.1",
    "@storeblocks/card-ng": "^19.0.0",
    "@storeblocks/checkbox-ng": "^17.2.2",
    "@storeblocks/chip-ng": "^16.0.2",
    "@storeblocks/empty-state-ng": "^18.1.1",
    "@storeblocks/form-ng": "^17.1.0",
    "@storeblocks/header-footer": "^2.6.2",
    "@storeblocks/icon-ng": "^20.0.3",
    "@storeblocks/inline-alert-ng": "^15.0.3",
    "@storeblocks/link-list-ng": "^16.0.1",
    "@storeblocks/loading-indicator-dots-ng": "^17.0.4",
    "@storeblocks/loading-indicator-linear-ng": "^16.0.1",
    "@storeblocks/modal-ng": "^22.1.0",
    "@storeblocks/popover-ng": "^18.2.2",
    "@storeblocks/radio-buttons-ng": "^17.0.3",
    "@storeblocks/skeleton-ng": "^18.1.1",
    "@storeblocks/surface-ng": "^3.0.1",
    "@storeblocks/switch-ng": "^17.0.1",
    "@storeblocks/table-ng": "^16.0.1",
    "@storeblocks/tabs-ng": "^19.0.0",
    "@storeblocks/toast-ng": "^17.0.0",
    "@storeblocks/tooltip-ng": "^17.0.1",
    "@storebrand-digital/auth": "^1.13.2",
    "@storebrand-digital/common-datadog": "^2.6.4",
    "@storebrand-digital/fms-translations": "^3.1.0",
    "@storebrand-digital/mock-ai-chat-widget": "^1.0.0",
    "@storebrand-digital/pretzel-assets": "^9.11.3",
    "angular-in-memory-web-api": "^0.22.0",
    "apollo-angular": "^14.1.0",
    "date-fns": "^2.30.0",
    "graphql": "^16.14.2",
    "highcharts": "^11.4.8",
    "highcharts-angular": "^4.0.1",
    "immer": "^10.2.0",
    "keycloak-js": "^21.1.2",
    "lottie-web": "^5.13.0",
    "nouislider": "^15.8.1",
    "rxjs": "7.8.1",
    "shepherd.js": "^11.2.0",
    "tslib": "^2.8.1",
    "unleash-proxy-client": "^3.8.0",
    "util": "^0.12.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.7.5",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/eslint-plugin": "^22.1.0",
    "@angular-eslint/eslint-plugin-template": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular-eslint/template-parser": "^22.1.0",
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/language-service": "^22.2.1",
    "@apidevtools/json-schema-ref-parser": "^15.5.0",
    "@commitlint/cli": "^18.6.1",
    "@commitlint/config-conventional": "^18.6.3",
    "@eslint/js": "^9.39.5",
    "@faker-js/faker": "^10.6.0",
    "@graphql-codegen/add": "^7.1.1",
    "@graphql-codegen/cli": "^7.4.6",
    "@graphql-codegen/typescript": "^6.1.2",
    "@graphql-tools/utils": "^12.1.0",
    "@playwright/test": "^1.61.1",
    "@storebrand-digital/fms-translations-cli": "^1.3.2",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/jsdom": "^30.0.0",
    "@types/node": "^24.13.3",
    "@vitest/coverage-v8": "^4.1.10",
    "@vitest/ui": "^4.1.10",
    "autoprefixer": "^10.5.4",
    "brotli": "^1.3.3",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-destructure-depth": "^1.0.3",
    "eslint-plugin-fp": "^2.3.0",
    "husky": "^8.0.3",
    "is-ci": "^3.0.1",
    "jsdom": "^28.1.0",
    "lint-staged": "^16.4.0",
    "ng-openapi-gen": "^1.0.5",
    "postcss": "^8.5.23",
    "prettier": "^3.9.6",
    "rimraf": "^6.1.3",
    "tailwindcss": "^4.3.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.62.0",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.10"
  }
}
